import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";

import { EffectCards } from "swiper/modules";
import w1 from "../assets/w1.jpg";
import w2 from "../assets/lawn.jpeg";
import w3 from "../assets/tree.jpg";
import w4 from "../assets/irrigation.jpg";
import w5 from "../assets/w5.jpg";
import w6 from "../assets/w6.jpg";
import w7 from "../assets/w7.jpg";
import w8 from "../assets/w8.jpg";
import { Link } from "react-router-dom";
const Welcome = () => {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth <= 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [window.innerWidth]);
  const [currentGallery, setCurrentGallery] = useState(gallery1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentGallery((prevGallery) =>
        prevGallery === gallery1 ? gallery2 : gallery1
      );
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="bg-yellow-50">
      <div className="flex flex-col md:flex-row gap-8 max-screen py-10 lg:py-20">
        <div className="flex-1 flex flex-col gap-6">
          <h2 className="text-4xl font-bold text-neutral-1">
            Welcome to A&L Landscaping
          </h2>
          <div className="flex flex-col gap-2 text-neutral-3">
            <p className="">
              At A&L Landscaping, we specialize in turning ordinary outdoor
              spaces into extraordinary havens of beauty and serenity. With a
              rich heritage spanning over four decades, we've been at the
              forefront of the landscaping and lawn care industry, shaping
              landscapes that inspire and nurturing lawns to lush perfection.
            </p>
            <p>
              {" "}
              Our passion lies in crafting living works of art, transforming
              your visions into reality. Whether it's a meticulously designed
              garden retreat or a flourishing lawn that beckons you to relax, we
              pride ourselves on our unwavering commitment to quality,
              creativity, and customer satisfaction.
            </p>
            <p>
              Join us on a journey where nature's canvas meets our expertise,
              and together, we'll create outdoor sanctuaries that reflect your
              unique personality and style. Explore our range of services and
              let A&L Landscaping be your trusted partner in sculpting
              landscapes and maintaining lawns that bring joy, tranquility, and
              a touch of nature's wonder to your everyday life. Welcome to a
              world of A&L Landscaping, where your outdoor dreams come to life.
            </p>
          </div>
          <div>
            <Link to="/about" className="btn btn-main">
              Learn More
            </Link>
          </div>
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="bg-yellow-50 absolute -top-2 -right-2 px-3 py-2 rounded-xl z-20">
            <CircleIndicator />
          </div>
          {mobile ? (
            <div className="card-gallery">
              <Swiper
                effect={"cards"}
                grabCursor={true}
                modules={[EffectCards]}
                className="">
                {currentGallery.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <img
                        src={item}
                        alt="gallery"
                        className="aspect-square object-cover"
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          ) : (
            <div className="grid-gallery h-[600px]">
              {currentGallery.map((item, index) => {
                return (
                  <div
                    className={`div${index + 1} overflow-hidden rounded-xl`}
                    key={index}>
                    <img
                      src={item}
                      alt="gallery"
                      className="transition-all  duration-500 hover:!scale-105 "
                      data-aos={index % 2 === 0 ? "flip-right" : "flip-left"}
                      data-aos-easing="ease-out-cubic"
                      data-aos-duration="2000"
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Welcome;

const gallery1 = [w2, w3, w4, w1];
const gallery2 = [w5, w6, w7, w8];

const CircleIndicator = () => {
  useEffect(() => {
    const circle = document.querySelector(".circle");
    const interval = 5000;

    function startCarouselIndicator() {
      circle.classList.remove("active");
      void circle.offsetWidth;
      circle.classList.add("active");
    }

    setInterval(startCarouselIndicator, interval);
  }, []);
  return (
    <div className="circle active">
      <svg viewBox="0 0 52 52" className="circle-back">
        <circle cx="26" cy="26" r="25" />
      </svg>
      <svg viewBox="0 0 52 52" className="circle-front">
        <circle cx="26" cy="26" r="25" />
      </svg>
    </div>
  );
};
